import React from 'react';
import BenefitJobCard from './BenefitJobCard';

export default function BenefitJobGrid({items}) {
    return (
        <div className="benefits-job-grid">
            {items.map((b, index) => (
                <BenefitJobCard key={index} title={b.title} descriptions={b.short_description} image={b.image_url} />
            ))}
        </div>
    );
}
